import { CSSProperties } from "react";

export const RouteUnlockedIcon = (style: CSSProperties) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <mask
        id="mask0_6396_4474"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="18"
        height="18"
      >
        <rect width="18" height="18" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6396_4474)">
        <path
          d="M4.5 15H13.5V7.5H4.5V15ZM9 12.75C9.4125 12.75 9.76563 12.6031 10.0594 12.3094C10.3531 12.0156 10.5 11.6625 10.5 11.25C10.5 10.8375 10.3531 10.4844 10.0594 10.1906C9.76563 9.89688 9.4125 9.75 9 9.75C8.5875 9.75 8.23438 9.89688 7.94063 10.1906C7.64687 10.4844 7.5 10.8375 7.5 11.25C7.5 11.6625 7.64687 12.0156 7.94063 12.3094C8.23438 12.6031 8.5875 12.75 9 12.75ZM4.5 16.5C4.0875 16.5 3.73438 16.3531 3.44063 16.0594C3.14688 15.7656 3 15.4125 3 15V7.5C3 7.0875 3.14688 6.73438 3.44063 6.44063C3.73438 6.14687 4.0875 6 4.5 6H9.75V4.5C9.75 3.4625 10.1156 2.57812 10.8469 1.84687C11.5781 1.11562 12.4625 0.75 13.5 0.75C14.5375 0.75 15.4219 1.11562 16.1531 1.84687C16.8844 2.57812 17.25 3.4625 17.25 4.5H15.75C15.75 3.875 15.5312 3.34375 15.0938 2.90625C14.6562 2.46875 14.125 2.25 13.5 2.25C12.875 2.25 12.3438 2.46875 11.9062 2.90625C11.4688 3.34375 11.25 3.875 11.25 4.5V6H13.5C13.9125 6 14.2656 6.14687 14.5594 6.44063C14.8531 6.73438 15 7.0875 15 7.5V15C15 15.4125 14.8531 15.7656 14.5594 16.0594C14.2656 16.3531 13.9125 16.5 13.5 16.5H4.5Z"
          fill="#8ACEFF"
        />
      </g>
    </svg>
  );
};
